import { toastService } from "./toast-service";
import { config } from "../../config";
import store from "../../store";

//Confluence: https://myameriflex.atlassian.net/wiki/spaces/DEVELOPMEN/pages/32538625/SPA+API+error+handling

class RomeError {
    _handled = false;
    _message = null;
    _error = null;

    get message() {
        if (!this.calledFromVueConsoleOutput()) this._handled = true;
        return this._message;
    };

    calledFromVueConsoleOutput() {
        let stack = (new Error() && new Error().stack) || "";
        return (stack.includes("globalHandleError") && stack.includes("handleError"));
    }

    toString() {
        return this.message + ", " + this._error.stack ? this._error.stack.substr(0, 200) : "";
    }

    hjTagError(errorType) {
        console.log(`Tagging hotjar error: ${errorType}`);
        hj('tagRecording', ["Error"]);
        hj('tagRecording', [`Error: ${errorType}`]);
    }

    constructor(error) {
        this._error = error;
        this._message = this.getErrorMessage(error);
    }

    getErrorMessage(err) {
        const romeValidationException = "RomeValidationException";
        let msg = null;

        if (err.response) {
            if (err.response.status === 404) {
                msg = "Not found: " + err.config.url;
            } else if (err.response.status === 401) {
                if (err.response.data && err.response.data.Type)
                    this.hjTagError(err.response.data.Type);
                msg = "Authorization error";
            } else if (err.response.statusText === "abort") {
                msg = null;
            } else if (err.response.status === 0) {
                msg = "No connection to the API";
            } else {
                if (err.response && _.isArray(err.response.data)) {
                  msg = "";
                  err.response.data.forEach(function(e) {
                    if(_.isString(e)){
                        msg += e + '; ';
                    } else {
                        msg += JSON.stringify(e) + '; ';
                    }
                  });

                } else if (err.response.data) {
                    if (err.response.data.Type && err.response.data.Type != romeValidationException)
                        this.hjTagError(err.response.data.Type);
                    if (_.isArray(err.response.data) && err.response.data.length > 0)
                        msg = err.response.data.join(" ");
                    msg = msg || err.response.data.ErrorMessage || err.response.data.errorMessage;
                } else if (!msg && err.response.responseText) {
                    msg = JSON.parse(err.response.responseText);
                    msg = msg.ErrorMessage || msg.exceptionMessage || msg.messageDetail || msg;
                }

                if (!msg && err.response.statusText) {
                    msg = err.response.statusText;
                }
            }
        } else {
            if (err.message) {
                msg = err.message;
            } else {
                msg = JSON.stringify(err);
            }
        }

        return msg;
    }
}

export default RomeError;




// WEBPACK FOOTER //
// ./src/framework/utils/rome-error.js